import { combineReducers } from "@reduxjs/toolkit";

import { amenitiesListingReducer } from "./AmenitiesSlice";

export const amenitiesReducer = combineReducers({
  amenities: amenitiesListingReducer,
});
